import { Handle, Position } from "@xyflow/react";
import { Input, Select } from "antd";
import {
  UsergroupAddOutlined, MailOutlined, ApiOutlined, EditOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";

const { Option } = Select;

const ICONS = {
  addToGroup:      <UsergroupAddOutlined style={{ color: "#10b981" }} />,
  removeFromGroup: <UsergroupAddOutlined style={{ color: "#ef4444" }} />,
  updateContact:   <EditOutlined        style={{ color: "#f59e0b" }} />,
  sendEmail:       <MailOutlined        style={{ color: "#3b82f6" }} />,
  webhook:         <ApiOutlined         style={{ color: "#8b5cf6" }} />,
};

const TITLES = {
  addToGroup:      "Add to Group",
  removeFromGroup: "Remove from Group",
  updateContact:   "Update Contact",
  sendEmail:       "Send Email",
  webhook:         "Webhook",
};

const CONTACT_FIELDS = [
  { value: "status",      label: "Status" },
  { value: "notes",       label: "Note" },
  { value: "designation", label: "Designation" },
  { value: "company",     label: "Company" },
  { value: "website",     label: "Website" },
];

const ActionNode = ({ data, selected, type }) => {
  const allTags = useSelector((s) => s.tags.tags) || [];
  const onChange = (field, value) => data.onChange?.({ ...data, [field]: value });

  const color = {
    addToGroup:      "#10b981",
    removeFromGroup: "#ef4444",
    updateContact:   "#f59e0b",
    sendEmail:       "#3b82f6",
    webhook:         "#8b5cf6",
  }[type] || "#6b7280";

  return (
    <div style={{
      background: "#fff",
      border: `2px solid ${selected ? color : "#e5e7eb"}`,
      borderRadius: 10,
      padding: 14,
      minWidth: 260,
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    }}>
      <Handle type="target" position={Position.Left} style={{ background: color }} />

      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
        {ICONS[type]}
        <strong style={{ fontSize: 13 }}>{TITLES[type]}</strong>
      </div>

      {/* Add / Remove from Group */}
      {(type === "addToGroup" || type === "removeFromGroup") && (
        <>
          <label style={{ fontSize: 11, color: "#6b7280", display: "block", marginBottom: 4 }}>Group</label>
          <Select
            value={data.tagId}
            onChange={(v, opt) => { onChange("tagId", v); onChange("tagName", opt?.label); }}
            size="small"
            style={{ width: "100%" }}
            placeholder="Select group"
            options={allTags.map((t) => ({ value: t.tag_id, label: `${t.emoji || ""} ${t.tag}` }))}
          />
        </>
      )}

      {/* Update Contact */}
      {type === "updateContact" && (
        <>
          <label style={{ fontSize: 11, color: "#6b7280", display: "block", marginBottom: 4 }}>Field</label>
          <Select
            value={data.field}
            onChange={(v) => onChange("field", v)}
            size="small"
            style={{ width: "100%", marginBottom: 8 }}
            placeholder="Select field"
            options={CONTACT_FIELDS}
          />
          <label style={{ fontSize: 11, color: "#6b7280", display: "block", marginBottom: 4 }}>Value</label>
          <Input
            value={data.value || ""}
            onChange={(e) => onChange("value", e.target.value)}
            size="small"
            placeholder="Enter value"
          />
        </>
      )}

      {/* Send Email */}
      {type === "sendEmail" && (
        <>
          <label style={{ fontSize: 11, color: "#6b7280", display: "block", marginBottom: 4 }}>Subject</label>
          <Input
            value={data.subject || ""}
            onChange={(e) => onChange("subject", e.target.value)}
            size="small"
            style={{ marginBottom: 8 }}
          />
          <label style={{ fontSize: 11, color: "#6b7280", display: "block", marginBottom: 4 }}>Body</label>
          <Input.TextArea
            value={data.body || ""}
            onChange={(e) => onChange("body", e.target.value)}
            rows={2}
            style={{ fontSize: 12 }}
          />
        </>
      )}

      {/* Webhook */}
      {type === "webhook" && (
        <>
          <label style={{ fontSize: 11, color: "#6b7280", display: "block", marginBottom: 4 }}>URL</label>
          <Input
            value={data.url || ""}
            onChange={(e) => onChange("url", e.target.value)}
            size="small"
            placeholder="https://..."
            style={{ marginBottom: 8 }}
          />
          <label style={{ fontSize: 11, color: "#6b7280", display: "block", marginBottom: 4 }}>Method</label>
          <Select
            value={data.method || "POST"}
            onChange={(v) => onChange("method", v)}
            size="small"
            style={{ width: "100%" }}
          >
            <Option value="POST">POST</Option>
            <Option value="GET">GET</Option>
          </Select>
        </>
      )}

      <Handle type="source" position={Position.Right} style={{ background: color }} />
    </div>
  );
};

export default ActionNode;
